// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19a2U","tabsBox":"styles_tabsBox__2QMTv","createButton":"styles_createButton__ZLWhl"};